export default __webpack_public_path__ + "static/media/BQ.d3d44c3f.svg";